import styled from 'styled-components'
import {StyledButton} from '@components/ui/button/style.ts'

export const StyledNewUserButton = styled(StyledButton)`
    flex-shrink: 0;
`
